import { render } from "./SocialMediaButtons.vue?vue&type=template&id=41358398&scoped=true&ts=true"
import script from "./SocialMediaButtons.vue?vue&type=script&lang=ts"
export * from "./SocialMediaButtons.vue?vue&type=script&lang=ts"

import "./SocialMediaButtons.vue?vue&type=style&index=0&id=41358398&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41358398"]])

export default __exports__